exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-title {\r\n    text-transform: none;\r\n}\r\n\r\n.block-title a {\r\n    color: #333;\r\n}\r\n\r\n.title-focus {\r\n    font-weight: 500;\r\n}\r\n\r\n.avaiable_status {\r\n    background: #62a8ea;\r\n    color: white;\r\n    border : 1px solid;\r\n}\r\n\r\n.unavaiable_status {\r\n    background: red;\r\n    color: white;\r\n    border : 1px solid;\r\n}\r\n\r\n.btn-tab {\r\n    padding: 5px 20px 5px 20px;\r\n}\r\n\r\n.active  {\r\n    background: #8e8e9a!important;\r\n    color: #fff!important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/pages/admin/icontact/monitor/monitor.css
// module id = ../../../../../src/app/pages/admin/icontact/monitor/monitor.css
// module chunks = main